import React from "react";
import { WACategoryTodoCategoriesScreenProps } from "./WACategoryTodoCategoriesNavigator";
import { WACategoryTodoCategorySelectTypeComponent } from "./WACategoryTodoCategorySelectTypeComponent";

export function WACategoryTodoCategoriesSelectType(
  props: WACategoryTodoCategoriesScreenProps<"WACategoryTodoCategoriesSelectType">
) {
  return (
    <WACategoryTodoCategorySelectTypeComponent
      categoryId={props.route.params.categoryId}
      storecastId={props.route.params.storecastId}
      onAdd={(type) => {
        if (type === "WidgetTodoSummary") {
          props.navigation.navigateDeprecated("WidgetAddTodoSummary", {
            categoryId: props.route.params.categoryId,
            storecastId: props.route.params.storecastId,
            defaultTeams: props.route.params.defaultTeams,
            unitSize: props.route.params.unitSize,
            maxSize: props.route.params.maxSize,
            position: props.route.params.position,
          });
        } else {
          props.navigation.navigateDeprecated("WidgetAddTodoCategory", {
            categoryId: props.route.params.categoryId,
            storecastId: props.route.params.storecastId,
            defaultTeams: props.route.params.defaultTeams,
            unitSize: props.route.params.unitSize,
            maxSize: props.route.params.maxSize,
            position: props.route.params.position,
          });
        }
      }}
      maxSize={props.route.params.maxSize}
      unitSize={props.route.params.unitSize}
    />
  );
}
